import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from '../components/Menu.vue'
import Home from '../views/Home.vue'
import Error404 from '../components/Error404.vue'



//participa
import Convocatoria from '@/views/participa/Convocatoria.vue'
import Inscripcion from '@/views/participa/Inscripcion.vue'
import Sede from '@/views/participa/Sede.vue'

//oqcdmx

import Historia from '@/views/oqcdmx/Historia.vue'
import Integrantes from '@/views/oqcdmx/Integrantes.vue'
import Participar from '@/views/oqcdmx/Participar.vue'

//olimpiadas

import Iberoamericana from '@/views/olimpiadas/Iberoamericana.vue'
import Internacional from '@/views/olimpiadas/Internacional.vue'
import Nacional from '@/views/olimpiadas/Nacional.vue'

import Contacto from '@/views/Contacto.vue'
import Material from '@/views/Material.vue'
import Resultado from '@/views/Resultado.vue'
import Galeria from '@/views/Galeria.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Menu,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: '/participa/convocatoria',
        component: Convocatoria,
        name: 'Convocatoria'
      },
      {
        path: '/participa/inscripcion',
        component: Inscripcion,
        name: 'Inscripcion'
      },
      {
        path: '/participa/sedes',
        component: Sede,
        name: 'Sedes'
      },
      {
        path: '/oqcdmx/historia',
        component: Historia,
        name: 'Historia'
      },
      {
        path: '/oqcdmx/integrantes',
        component: Integrantes,
        name: 'Integrantes'
      },
      {
        path: '/oqcdmx/participar',
        component: Participar,
        name: 'Participar'
      },
      {
        path: '/olimpiadas/iberoamericana',
        component: Iberoamericana,
        name: 'Iberoamericana'
      },
      {
        path: '/olimpiadas/internacional',
        component: Internacional,
        name: 'Internacional'
      },
      {
        path: '/olimpiadas/nacional',
        component: Nacional,
        name: 'Nacional'
      },
      {
        path: '/contacto',
        component: Contacto,
        name: 'Contacto'
      },
      {
        path: '/material',
        component: Material,
        name: 'Material'
      },
      {
        path: '/resultado',
        component: Resultado,
        name: 'Resultado'
      },
      {
        path: '/galeria',
        component: Galeria,
        name: 'Galeria'
      },

    ]

  },
  {
    path: '*',
    name: '404',
    component: Error404
  }

    
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
